import { FC } from 'react';
import 'animate.css';
import { RouterProvider } from 'react-router-dom';
import { MainRoutes } from './Router/Root';
import { ToastProvider } from './context/Toast/ToastProvider';
import { ThemeProvider } from '@material-tailwind/react';
import { AppLoader, useGlobalTranslate, AbilityProvider } from '@jaam/web-core';
import { AppProfiler } from './AppProfiler';

const AppWrapper: FC = () => {
  useGlobalTranslate();

  return (
    <AppProfiler id="payrollr-web-app">
      <AbilityProvider>
        <ThemeProvider>
          <ToastProvider>
            <RouterProvider
              router={MainRoutes}
              fallbackElement={
                <div className="">
                  <AppLoader />
                </div>
              }
            />
          </ToastProvider>
        </ThemeProvider>
      </AbilityProvider>
    </AppProfiler>
  );
};

export default AppWrapper;
